import React from 'react'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded'
import dayjs from 'dayjs'
import { BarChart } from '@mui/x-charts/BarChart'

import { useIsOptimised, useSavedAmountPerMonth } from '../hooks/use-estate'
import { convertFromCents } from '../helpers'

const MONTH_NAMES = [
    'Led',
    'Ún',
    'Bře',
    'Dub',
    'Kvě',
    'Črv',
    'Čvn',
    'Srp',
    'Zář',
    'Říj',
    'List',
    'Pro',
]

function SavedAmountGraph({ estateId }) {
    const optimization = useIsOptimised(estateId)
    const saved = useSavedAmountPerMonth(estateId)

    const data = React.useRef<{
        xAxis: string[]
        series: number[]
    }>({
        xAxis: [],
        series: [],
    })

    React.useEffect(() => {
        data.current.xAxis = []
        data.current.series = []
        if (saved.data?.saved_amount_cents) {
            const MONTHS = saved.data.saved_amount_cents.length
            for (let i = 0; i < MONTHS; i++) {
                const item =
                    saved.data.saved_amount_cents[saved.data.saved_amount_cents.length - 1 - i]
                const value: number = convertFromCents( item.amount )
                const month: string = MONTH_NAMES[dayjs(item.from).month()]

                data.current.xAxis.push(month)
                data.current.series.push(value)
            }
        }
    }, [saved.data?.saved_amount_cents])

    if (saved.status === 'pending') {
        return <CircularProgress />
    }

    if (saved.error) {
        return (
            <Box>
                <ErrorOutlineRoundedIcon />
                <Box>{saved.error.message}</Box>
            </Box>
        )
    }

    //
    // Do not show graph if optimization is not active
    //
    if (optimization.status === 'pending') {
        return <CircularProgress />
    }
    if (optimization.error) {
        return (
            <Box>
                <ErrorOutlineRoundedIcon />
                <Box>{optimization.error.message}</Box>
            </Box>
        )
    }
    if(!optimization.data.optimalization_is_active) {
        return
    }

    // BarChart crashes on empty array
    if (!saved.data || data.current.series.length < 1) {
        return <></>
    }

    return (
        <BarChart
            height={300}
            // sx is for <svg> element
            sx={{
                padding: '0 0 0 1.5rem',
                overflow: 'visible', // make yAxis label's text not be cut off
                '& .MuiChartsAxis-label': {
                    transform: 'translate(-16px, 0px)', // yAxis label
                },
            }}
            series={[
                {
                    data: data.current.series, // [1,2,3]
                },
            ]}
            yAxis={[
                {
                    label: 'úspora (Kč)',
                    // labelStyle: {
                    //     padding: '5px',
                    //     offset: '3px 8px',
                    // },
                },
            ]}
            xAxis={[
                {
                    scaleType: 'band',
                    data: data.current.xAxis, // ['a','b','c'],
                },
            ]}
        />
    )
}
export default SavedAmountGraph
